/** 公布给家长 / 已公布(作业、考试)。家长端只显示已公布的分数(博颂 2026-09-24:成绩发不发由老师决定)。 */
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { authHeaders } from "@/api/school";

export function PublishToggle({ kind, id, publishedAt }: { kind: "assignments" | "exams"; id: string; publishedAt?: string | null }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [on, setOn] = useState(!!publishedAt);
  const [notified, setNotified] = useState<number | null>(null);
  async function toggle() {
    setBusy(true);
    try {
      const r = await fetch(`/api/school/${kind}/${id}/publish`, {
        method: "PUT",
        headers: { ...authHeaders(), "Content-Type": "application/json" },
        body: JSON.stringify({ published: !on }),
      });
      if (r.ok) {
        const body = (await r.json().catch(() => ({}))) as { notified?: number };
        setNotified(!on && body.notified ? body.notified : null);
        setOn(!on);
        void qc.invalidateQueries({ queryKey: ["school"] });
      }
    } finally {
      setBusy(false);
    }
  }
  return (
    <span className="inline-flex items-center gap-2">
    {notified ? <span className="text-xs text-emerald-700">{t("gpa.publish.notified", { n: notified })}</span> : null}
    <button
      type="button"
      disabled={busy}
      onClick={(e) => { e.stopPropagation(); void toggle(); }}
      title={t("gpa.publish.hint")}
      data-testid={`publish-${kind}-${id}`}
      className={`rounded border px-3 py-1 text-xs ${on ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "border-slate-300 bg-white text-slate-700 hover:bg-slate-100"} disabled:opacity-50`}
    >
      {on ? t("gpa.publish.on") : t("gpa.publish.off")}
    </button>
    </span>
  );
}
